// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cards-table[data-v-3f357140] {\r\n  background-color: var(--v-primary-lighten2);\n}\r\n", ""]);
// Exports
module.exports = exports;
